import { UniversalFilterConfig } from "../../components/Filters/ReportFilter";

/**
 * 📦 Kárdex de inventarios general
 *
 * Backend esperado: branchId, dateFrom, dateTo
 */
export const kardexInventoryReportFilters: UniversalFilterConfig[] = [
  {
    name: "branchId",
    label: "Sucursal",
    type: "select",
    iconKey: "branch",
  },
  {
    name: "dateFrom",
    label: "Fecha Desde",
    type: "date",
    iconKey: "calendar",
  },
  {
    name: "dateTo",
    label: "Fecha Hasta",
    type: "date",
    iconKey: "calendar",
  },
];
